import { Typography } from '@mui/material';
import { PAGE } from '@schooly/constants';
import React, { FC, RefAttributes } from 'react';
import { FormattedMessage } from 'react-intl';

import './index.scss';

interface IHeaderProps {
  pageTitleTextId?: string;

  testId?: string;
}

const Header: FC<any & RefAttributes<HTMLDivElement>> = React.forwardRef<
  HTMLDivElement,
  IHeaderProps
>(({ pageTitleTextId, testId }, ref) => {
  return (
    <div className="Header">
      <Typography
        variant="h1"
        className="Header__page-title"
        pr={5}
        sx={{ display: 'flex', alignItems: 'center' }}
        data-test-id={PAGE.HEADER_TITLE}
      >
        <FormattedMessage id={pageTitleTextId} />
      </Typography>
    </div>
  );
});

export default Header;
